// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ReceiptTaxIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ReceiptTax/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 14 6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2ZM10 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm5 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
}));
export default ReceiptTaxIcon;